import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import Chrome from '../components/Chrome';
import Header from '@material-ui/core/AppBar';
require('prismjs/themes/prism.css');

import './index.css';

const TemplateWrapper = ({ children }) => (
    <div>
        <Chrome header={<Header />}>
            <Helmet
                title="Signiant Help"
                meta={[
                    { name: 'description', content: 'Signiant Help' },
                    {
                        name: 'keywords',
                        content:
                            'flight, signiant, gateway, signiant flight gateway' +
                            ', flight cli help, help flight gateway, endpoints' +
                            ', manager+agents, manager, agent, transfer',
                    },
                ]} // add more later
            >
                <link
                    rel="shortcut icon"
                    type="image/x-icon"
                    href="https://signiant-documentation.s3.amazonaws.com/help-core/favicon.ico"
                ></link>
                <link
                    rel="stylesheet"
                    href="https://cdn.jsdelivr.net/npm/docsearch.js@2/dist/cdn/docsearch.min.css"
                ></link>
                <script src="https://app-sj07.marketo.com/js/forms2/js/forms2.min.js"></script>
            </Helmet>

            <div className="layout-content">{children}</div>
        </Chrome>
    </div>
);

TemplateWrapper.propTypes = {
    children: PropTypes.object,
};

export default TemplateWrapper;
